module.exports = __webpack_public_path__ + "img/Hardware.f0d98871.svg";